import React from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import TableroExpedientes from './components/TableroExpedientes';import NuevoExpediente from './components/NuevoExpediente';
import DetalleOperacion from './components/DetalleOperacion';
import ExpedienteSujeto from './components/ExpedienteSujeto';

/**
 * Rutas internas del módulo PLD bajo /:unidad/pld.
 */
export default function ModuloPLD() {
    const { path } = useRouteMatch();

    return (
        <Switch>
            <Route path={`${path}/nuevo`} exact component={NuevoExpediente} />
            <Route path={`${path}/:operacionId/editar`} exact component={NuevoExpediente} />
            <Route path={`${path}/:operacionId/sujeto/:sujetoId/:relacionId`} exact component={ExpedienteSujeto} />
            <Route path={`${path}/:operacionId`} exact component={DetalleOperacion} />
            <Route path={path} exact>
                <TableroExpedientes />
            </Route>
        </Switch>
    );
}
